import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'tanok';

import * as a from './../../../libs/actions';
import * as c from './../../../libs/constants';

import { Header } from './header';
import { Login } from './body/login';
import { Register } from './body/register';
import { Start } from './body/start';

import { Layout } from '../../ui/layout';

class AuthenticationView extends React.Component {
    static propTypes = {
        activeAuthTab: PropTypes.string,
        closeDialog: PropTypes.func,
    };

    changeAuthTab = (tabName, action) => {
        return () => {
            this.props.send(a.EVENT_AUTH_CHANGE_TAB, { tabName });
            action && this.props.send(
                a.TR_SEND_ANALITICS_ACTION,
                { action });
        };
    }

    sendAnaliticsAction = (action) => {
        return () => this.props.send(a.TR_SEND_ANALITICS_ACTION, { action });
    }

    render() {
        const { closeDialog, activeAuthTab } = this.props;
        let Body = <noscript />;

        switch (activeAuthTab) {
            case c.CHAT_AUTH_LOGIN:
                Body = Login;
                break;
            case c.CHAT_AUTH_REGISTER:
                Body = Register;
                break;
            default:
                Body = Start;
        }

        return (
            <Layout key='containerBesida' dataQa='besida_panel_block'>
                <Layout.Header>
                    <Header
                        closeDialog={closeDialog}
                        changeAuthTab={this.changeAuthTab}
                    />
                </Layout.Header>
                <Layout.Body>
                    <Body
                        sendAnaliticsAction={this.sendAnaliticsAction}
                        changeAuthTab={this.changeAuthTab}
                    />
                </Layout.Body>
            </Layout>
        );
    }
}

const mapStateToProps = (state) => ({
    activeAuthTab: state.get('activeAuthTab'),
    errors: state.get('errors'),
});

export const Authentication = connect(mapStateToProps)(AuthenticationView);
